<div class="page-layout simple full-width">

    <!-- HEADER -->
    <!--<app-title-bar [title]="'Certificados'">
        <button [routerLink]="'/certificate-add'" mat-raised-button>
            <span>Crear Certificado</span>
        </button>
    </app-title-bar>-->
    <!-- / HEADER -->
    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Slider </div>
        </div>

        <button [routerLink]="'/slider-add'" mat-raised-button>
            <span>Crear nuevo!</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- SELECTED BAR -->
    <!--<selected-bar class="accent-600" *ngIf="hasSelectedContacts" [@slideInTop]></selected-bar>-->
    <!-- / SELECTED BAR -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>



            <!-- CONTENT -->
            <div class="content">

                <div class="container-table">
                    <mat-table #table [dataSource]="dataItems.data" [@animateStagger]="{value:'50'}">

                        <ng-container *ngFor="let column of configColumns" [matColumnDef]="column.key">
                            <mat-header-cell *matHeaderCellDef>{{ column.title }}</mat-header-cell>
                            <mat-cell *matCellDef="let item">
                                <p [ngClass]="{'text-truncate': column.type == 'integer'}" class="{{ column.classes }}">{{ column.call(item) }}</p>
                            </mat-cell>
                        </ng-container>

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="actions" stickyEnd>
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let item">
                                <div fxFlex="row" fxLayoutAlign="end center">

                                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="Acciones" (click)="$event.stopPropagation();">
                                        <mat-icon class="secondary-text">more_vert</mat-icon>
                                    </button>

                                    <mat-menu #moreMenu="matMenu">
                                        <button [routerLink]="'/slider-edit/' + item.id" mat-menu-item aria-label="edit">
                                                <mat-icon>edit</mat-icon>
                                                <span>Editar</span>
                                            </button>
                                        <button mat-menu-item aria-label="remove" [swal]="{ title: 'Eliminar ' + item.id, text: '¿Se encuentra seguro de eliminar?', type: 'warning', focusCancel: true, showCancelButton: true, confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' }"
                                            (confirm)="onRemove(item)">
                                                <mat-icon>delete</mat-icon>
                                                <span>Eliminar</span>
                                            </button>
                                    </mat-menu>
                                </div>

                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let item; columns: displayedColumns;" class="boat" (click)="openItem(item)" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
                        </mat-row>
                    </mat-table>
                </div>


                <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
                    <mat-progress-spinner color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </mat-card>



            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>